export default __webpack_public_path__ + "static/media/3.f12626d0.svg";